/**
 * Created by yangxy on 2023/01/03.
 * 左侧菜单栏相关
 */
const state = {
  isCollapse: false // 是否折叠，默认不折叠
};

// mutations
const mutations = {
  setCollapse: (state, val) => {
    state.isCollapse = val;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
